export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0047AB]/20 via-black to-black"></div>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#0047AB] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#0047AB] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto w-full relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-left space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
                Gamer Station: O Seu Próximo Nível em <span className="text-[#0047AB]">Consoles e Games</span> Começa Aqui! 🎮
              </h1>
              <p className="text-lg sm:text-xl text-gray-300 leading-relaxed">
                A maior autoridade da <strong className="text-white">Santa Ifigênia</strong> agora ao seu alcance. Preço justo, garantia real e o estoque mais completo de <strong className="text-white">São Paulo</strong>. PS5, Xbox Series e Nintendo Switch já estão prontos para entrega.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://wa.me/5511951063038" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-[#0047AB] text-white px-8 py-4 rounded-lg hover:bg-[#003380] transition-all duration-300 text-lg font-bold text-center cursor-pointer shadow-2xl shadow-[#0047AB]/50 hover:shadow-[#0047AB]/70 hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                QUERO CONSULTAR PREÇOS AGORA
              </a>
            </div>

            <div className="flex flex-wrap gap-8 pt-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#0047AB]/20 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-[#0047AB]"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">Garantia Oficial</p>
                  <p className="text-gray-400 text-xs">Todos os produtos</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#0047AB]/20 rounded-lg flex items-center justify-center">
                  <i className="ri-store-2-line text-2xl text-[#0047AB]"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">Loja Física</p>
                  <p className="text-gray-400 text-xs">Santa Ifigênia, SP</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#0047AB]/20 rounded-lg flex items-center justify-center">
                  <i className="ri-truck-line text-2xl text-[#0047AB]"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">Entrega Rápida</p>
                  <p className="text-gray-400 text-xs">Todo o Brasil</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl shadow-[#0047AB]/30 border-2 border-[#0047AB]/30">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/1MfhyK1-HJg"
                title="Gamer Station - Loja de Games Santa Ifigênia"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#0047AB] rounded-full blur-3xl opacity-50"></div>
          </div>
        </div>
      </div>
    </section>
  );
}